import React, { useState, useEffect } from "react";
import { Modal } from "../../../../Components";
import { useNavigate } from 'react-router-dom';
export default function ModalCsvExportConfirm(props) {
    const navigate = useNavigate();
    const [requested, setRequested] = useState(props.csvPreviewDetails.rows_requested);
    const [available, setAvailabe] = useState(props.csvPreviewDetails.rows_available);
    const goToPricing = () => {
        navigate("/brand/pricing");
    }
    return (
        <Modal addClass="modalCamp" close={props.close}>
            <div className="modal__camp">
                <div className="modal__assetDetail-delete perm long">
                    <h4>Exporting {requested} from available {available} quota.</h4>
                    {props.csvPreviewDetails.can_export === true ?
                        <div className="modal__assetDetail-delete-btns">
                            <button className="button secondary" onClick={props.close}>
                                Cancel
                            </button>
                            <button className="button primary" onClick={props.exportCsvFile}>
                                Proceed
                            </button>
                        </div> :
                        <div >
                            <div >
                                <h4>Not enough quota to complete export.</h4>
                            </div>
                            <div className="modal__assetDetail-delete-btns upgrade">
                                <button className="button primary" onClick={goToPricing}>
                                    Upgrade
                                </button>
                            </div>
                        </div>}
                </div>
            </div>
        </Modal>
    );
}

